/* eslint-disable */

export const getOrdersConstants = {
    GET_ORDERS_REQUEST: 'GET_ORDERS_REQUEST',
    GET_ORDERS_SUCCESS: 'GET_ORDERS_SUCCESS',
    GET_ORDERS_FAILURE: 'GET_ORDERS_FAILURE',
};
